import React from 'react';
import { FiX, FiMaximize, FiMinimize, FiDownload } from 'react-icons/fi';

export default function LessonContentModal({ isOpen, onClose, content, securitySettings }) {
    if (!isOpen || !content) return null;

    const { type, url, title, description } = content;

    const getEmbedUrl = (url) => {
        if (!url) return null;
        const ytRegex = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
        const ytMatch = url.match(ytRegex);
        if (ytMatch && ytMatch[2].length === 11) {
            return `https://www.youtube.com/embed/${ytMatch[2]}?rel=0&modestbranding=1&showinfo=0&autoplay=1`;
        }
        const vimeoRegex = /(?:vimeo)\.com.*(?:videos|video|channels|)\/([\d]+)/i;
        const vimeoMatch = url.match(vimeoRegex);
        if (vimeoMatch) {
            return `https://player.vimeo.com/video/${vimeoMatch[1]}?autoplay=1&badge=0&autopause=0&player_id=0&app_id=58479`;
        }
        return url;
    };

    const isDirectVideo = (url) => {
        return url && (url.endsWith('.mp4') || url.endsWith('.webm') || url.endsWith('.ogg'));
    };

    const isZoom = (url) => {
        return url && url.includes('zoom.us/rec/share');
    };

    return (
        <div className="fixed inset-0 z-[200] flex flex-col bg-black/95 backdrop-blur-md animate-in fade-in duration-300">
            {/* Modal Header */}
            <div className="flex items-center justify-between px-6 py-4 border-b border-white/10">
                <div className="flex-1 min-w-0">
                    <h3 className="text-white font-bold truncate">{title}</h3>
                    {description && (
                        <p className="text-gray-400 text-xs truncate mt-0.5">{description}</p>
                    )}
                </div>
                <div className="flex items-center gap-4 ml-4">
                    <button
                        onClick={onClose}
                        className="p-2 bg-white/10 hover:bg-white/20 text-white rounded-full transition-colors"
                        title="Close"
                    >
                        <FiX size={20} />
                    </button>
                </div>
            </div>

            {/* Modal Content */}
            <div className="flex-1 relative overflow-hidden flex items-center justify-center p-0 md:p-4">
                <div className="w-full h-full max-w-6xl mx-auto rounded-xl overflow-hidden shadow-2xl bg-black relative">
                    {type === 'video' ? (
                        <div className="w-full h-full relative">
                            {isDirectVideo(url) ? (
                                <video
                                    className="w-full h-full"
                                    controls
                                    autoPlay
                                    controlsList="nodownload"
                                    onContextMenu={(e) => e.preventDefault()}
                                >
                                    <source src={url} type="video/mp4" />
                                </video>
                            ) : isZoom(url) ? (
                                <iframe
                                    className="w-full h-[120%] -top-[15%] absolute"
                                    src={url}
                                    title={title}
                                    frameBorder="0"
                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                    allowFullScreen
                                ></iframe>
                            ) : (
                                <iframe
                                    className="w-full h-full"
                                    src={getEmbedUrl(url)}
                                    title={title}
                                    frameBorder="0"
                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                    allowFullScreen
                                ></iframe>
                            )}

                            {/* Watermark */}
                            {securitySettings?.screen_recording_watermark === '1' && (
                                <div className="absolute inset-0 pointer-events-none z-20 overflow-hidden opacity-20">
                                    <span className="absolute text-[12px] text-white/10 font-black uppercase rotate-[-30deg] select-none whitespace-nowrap" style={{ top: '20%', left: '10%' }}>
                                        SUDESH MATHS • PROTECTED CONTENT
                                    </span>
                                    <span className="absolute text-[12px] text-white/10 font-black uppercase rotate-[-30deg] select-none whitespace-nowrap" style={{ bottom: '25%', right: '15%' }}>
                                        SUDESH MATHS • PROTECTED CONTENT
                                    </span>
                                </div>
                            )}
                        </div>
                    ) : (
                        <div className="w-full h-full bg-white flex flex-col">
                            <iframe
                                className="w-full h-full"
                                src={url.includes('drive.google.com') ? url.replace(/\/view.*$/, '/preview') : url}
                                title={title}
                            ></iframe>
                            {securitySettings?.dev_tools_restricted === '1' && (
                                <div className="absolute top-0 left-0 right-0 h-14 bg-transparent z-10"></div>
                            )}
                        </div>
                    )}
                </div>
            </div>

            {/* Modal Footer / Progress Placeholder (Optional) */}
            <div className="px-6 py-4 bg-black/40 text-center">
                <p className="text-[10px] text-white/30 uppercase font-black tracking-widest">
                    Sudesh Maths Premium Learning Experience
                </p>
            </div>
        </div>
    );
}
